import commonFilterTpl from './views/commonFilter.html';
import './commonFilter.scss';
import commonFilterCtrl from './controllers/commonFilterController';


const name = 'commonFilter';
var module = angular.module("app.commonFilter", [

]).directive(name,
    function() {
        return {
            restrict: 'E',
            template: commonFilterTpl,
            bindToController: {
                stateId: '='
            },
            scope: true,
            controllerAs: "multipleBatchFilterCtrl",
            controller: ['$state', '$rootScope', '$scope', '$mdDialog', '$stateParams', 'localStorageService', 'authService', 'filterCons', 'CONSTANTS', 'CommonFilterRoleService',
                function($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, filterCons, CONSTANTS, CommonFilterRoleService) {

                    let userId = localStorageService.get('user_id');

                    let self = this;
                    var vm = this;
                    vm.limit = 50;
                    vm.Items = 60;
                    vm.pager = {};
                    vm.setPage = setPage;
                    vm.pageIndex = [];

                    function GetPager(totalItems, currentPage, pageSize) {
                        // default to first page
                        currentPage = currentPage || 1;
                        pageSize = pageSize || vm.limit;
                        var totalPages = Math.ceil(totalItems / pageSize);
                        var startPage, endPage;
                        if (totalPages <= 10) {
                            startPage = 1;
                            endPage = totalPages;
                        } else {
                            if (currentPage <= 6) {
                                startPage = 1;
                                endPage = 10;
                            } else if (currentPage + 4 >= totalPages) {
                                startPage = totalPages - 9;
                                endPage = totalPages;
                            } else {
                                startPage = currentPage - 5;
                                endPage = currentPage + 4;
                            }
                        }

                        var startIndex = (currentPage - 1) * pageSize;
                        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
                        var pages = _.range(startPage, endPage + 1);
                        return {
                            totalItems: totalItems,
                            currentPage: currentPage,
                            pageSize: pageSize,
                            totalPages: totalPages,
                            startPage: startPage,
                            endPage: endPage,
                            startIndex: startIndex,
                            endIndex: endIndex,
                            pages: pages
                        };
                    }

                    function initController() {
                        $scope.announcementForAll = self.checkAnnouncementReceivers
                        if (self.checkAnnouncementReceivers) {
                            console.log('SEND TO ALL')
                            self.getAllUsersForAnnouncement()
                            $scope.showFilteredUsers = false;
                        } else {
                            vm.setPage(1);
                        }
                    }

                    function setPage(page) {
                        if (page < 1 || page > vm.pager.totalPages) {
                            return;
                        }
                        vm.pager = GetPager(vm.Items, page);
                        console.log(vm.pager)
                        $scope.showFilteredUsers = true;
                        if (vm.pageIndex.indexOf(page) === -1) {

                            if (page === 1)
                                self.getUsersLists(0, vm.limit, page);
                            else
                                self.getUsersLists(vm.pager.startIndex, vm.limit, page);
                        } else {
                            findValueBasedOnIndex(page)
                        }
                    }

                    $scope.filteredEndorsedUsers = []
                    $scope.selectedFilterData = "Select.."
                    $scope.userNamesNotEndorsed = []
                    $scope.showAcademicFilters = true;
                    $scope.isBatch = false;
                    $scope.isClass = false;
                    self.checkAllClass = false;
                    $scope.showSavedSearch = false;
                    $scope.saveSearchData = false;
                    $scope.showbatch = true;
                    $scope.isSearched = false;
                    self.showMultiBatch = [];
                    self.showChart = [];
                    $scope.filterObj = {}
                    $scope.buttonName = 'Add'
                    $scope.open = false;
                    $scope.announcementForAll = false;

                    var everywhere = angular.element(window.document);
                    everywhere.bind('click', function(event) {

                        try {
                            var isButtonClick = event.target.className === "btn-filter btn-primary dropdown-toggle ng-binding";
                            if (isButtonClick === false) {
                                $scope.open = false;
                                _.defer(function() {
                                    $scope.$apply();
                                });;
                            }
                        } catch (ex) {

                        }
                    })


                    //self.subscribe('getAllFilter', () => [$scope.stateId, localStorageService.get('school_id')])

                    function findValueBasedOnIndex(page) {

                        $scope.userNamesNotEndorsed = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                            return user.page === page
                        })
                        self.userNotEndorsedAcademic = _.uniq(_.pluck($scope.userNamesNotEndorsed, 'academic_details'));

                    }

                    function clearUsersListResults() {
                        self.userNotEndorsedAcademic = [];
                        $scope.userNamesNotEndorsed = [];
                        $scope.filteredNotEndorsedUsers = [];
                        vm.pager = {};
                        vm.setPage = setPage;
                        vm.pageIndex = [];
                        self.allItemsSelected = [];
                    }

                    function clearFields() {
                        self.showMultiSubject = [];
                        $scope.filterObj['batch'] = [];
                        $scope.filterObj['subject'] = [];
                        $scope.isSubject = false;
                        self.checkAll = false;
                        self.checkAllSubject = false;
                        vm.pager = {};
                        vm.setPage = setPage;
                        clearUsersListResults();
                        vm.pageIndex = [];
                        self.allItemsSelected = [];
                    }


                    clearFields();

                    $scope.chartTypes = [{
                            name: 'Pie',
                            type: 'pie'
                        }, {
                            name: 'Bar',
                            type: 'Bar'
                        }, {
                            name: 'Doughnut',
                            type: 'Doughnut'
                        }

                    ];


                    function featureBaseFilter() {
                        console.log("***********************")
                        console.log($scope.stateId)
                        switch ($scope.stateId) {
                            case 'userManagement':
                                hideUserManagementFilterFields();
                                break;
                            case 'reportGradeDetailsConsole':
                                hideReportGradeDetailsConsoleFields();
                                break;
                            case 'announcementsUsers':
                                $scope.buttonName = 'Proceed'
                                $scope.announcementForAll = true
                                hideClubFilterFields();
                                break;
                            case 'club':
                                $scope.buttonName = 'Add'
                                hideClubFilterFields();
                                break;
                            case 'manageReportCards':
                                $scope.buttonName = 'Add'
                                hidefilterInManageReports()
                                break;
                            case 'viewDetails':
                                $scope.buttonName = 'Proceed'
                                forSecurityAppConsole();
                                break;
                            case 'transferStudent':
                                $scope.buttonName = 'Search'
                                roleasStudentOnly();
                                break;
                            case 'edituser':
                                $scope.buttonName = 'Search'
                                forEditinguser();
                                break;
                            case 'removeUser':
                                forRemoveUser();
                                break;
                            case 'userProfile':
                                $scope.buttonName = 'Search'
                                hideMedicalFilterFields();
                                break;
                            case 'createProgramme':
                                $scope.buttonName = 'Search'
                                hideMedicalFilterFields();
                                break;

                        }
                    }

                    featureBaseFilter();

                    function forRemoveUser() {
                        $scope.visibleRole = true;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = true;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                        $scope.showSavedSearchField = true;
                        $scope.showFilteredUsers = false;

                    }

                    function forEditinguser() {
                        $scope.visibleRole = true;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = true;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                        $scope.showSavedSearchField = false;
                        $scope.showFilteredUsers = false;
                    }

                    function hidefilterInManageReports() {
                        $scope.visibleRole = false;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = false;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = true;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                        $scope.showSavedSearchField = false;
                        $scope.showFilteredUsers = false;
                    }

                    function hideClubFilterFields() {
                        $scope.visibleRole = true;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = false;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = true;
                        $scope.showSavedSearchField = true;
                        $scope.showFilteredUsers = false;
                    }

                    function hideUserManagementFilterFields() {
                        $scope.visibleRole = true;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = true;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                        $scope.showSavedSearchField = true;
                        $scope.showFilteredUsers = true;

                    }

                    function roleasStudentOnly() {
                        $scope.visibleRole = false;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = true;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                        $scope.showSavedSearchField = true;
                        $scope.showFilteredUsers = false;

                        $scope.filterObj['role'] = 'student'
                        $scope.filterObj['role_id'] = 'student'
                    }

                    function forSecurityAppConsole() {
                        $scope.visibleRole = false;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = false;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = true;
                        $scope.showSavedSearchField = true;
                        $scope.showFilteredUsers = true;

                        $scope.filterObj['role'] = 'student'
                        $scope.filterObj['role_id'] = 'student'
                    }
                    function hideMedicalFilterFields() {
                        $scope.visibleRole = true;
                        $scope.showAcademicFilters = true;
                        $scope.showbatch = true;
                        $scope.showSubject = false;
                        $scope.showChart = false;
                        $scope.showMultiRole = false;
                        $scope.showDate = false;
                        $scope.blnsearchValuesBasedOnFilter = true;
                        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                        $scope.showSavedSearchField = true;
                        $scope.showFilteredUsers = false;
                    }

                    let subsModules = undefined,
                        subsAcademicSet = undefined,
                        subsAcademicPack = undefined,
                        academicDetail = undefined

                    /*
                     * To get user's assigned module's features
                     *
                     * @Developer : Jeevanantham N
                     */
                    let parentId = ''
                    let principalId = ''
                    let vicePrincipalId = ''
                    let senEducatorId = ''
                    let senCoordinatorId = ''
                    let senCounselorId = ''
                    let getUserModules = () => {
                        authService.callAPI(filterCons.API_GET_MODULE_FEATURE + localStorageService.get('school_id') + "/" + "roleSetting", "GET", {}, (response) => {
                            if (response.result && response.result.data && response.result.data.module_features) {
                                try {
                                    moduleDetails = response.result.data.module_features
                                    let principalId = ''
                                    let vicePrincipalId = ''
                                    let senEducatorId = ''
                                    let senCoordinatorId = ''
                                    let senCounselorId = ''
                                    if (moduleDetails != undefined && moduleDetails.feature_role && $scope.isClub) {

                                        _.each(moduleDetails.feature_role, function(each) {
                                            if (each.f_id == 'parentComponent' && each.privilege[0].status) {
                                                parentId = each.role_id
                                            } else if (each.f_id == 'principalComponent' && each.privilege[0].status) {
                                                principalId = each.role_id
                                            } else if (each.f_id == 'vicePrincipalComponent' && each.privilege[0].status) {
                                                vicePrincipalId = each.role_id
                                            } else if (each.f_id == 'senEducatorComponent' && each.privilege[0].status) {
                                                senEducatorId = each.role_id
                                            } else if (each.f_id == 'senCoordinatorComponent' && each.privilege[0].status) {
                                                senCoordinatorId = each.role_id
                                            } else if (each.f_id == 'senCounselorComponent' && each.privilege[0].status) {
                                                senCounselorId = each.role_id
                                            }
                                        })
                                    }
                                    _.defer(function() {
                                        $scope.$apply();
                                    });
                                } catch (ex) {
                                    console.log(ex)
                                }
                            }
                        })
                    }


                    /*
                     * To get school based academic deatils
                     *
                     * @Developer : Jeevanantham N
                     */
                    let getAcademicPck = () => {
                        authService.callAPI(filterCons.API_GET_SCHOOL_ACADEMICS + localStorageService.get('school_id'), "GET", {}, (response) => {
                            console.log(response)
                            if (response.result && response.result.data && response.result.data.academic_det) {
                                //$scope.hodPersonArr = response.result.data.departments

                                self.sessions = []
                                academicDetail = response.result.data.academic_det

                                if (academicDetail === undefined || academicDetail.length <= 0)
                                    return false;


                                if (self.allSessions && academicDetail) {
                                    _.each(academicDetail, function(doc) {
                                        let thisSessionDetails = _.find(self.allSessions.list, function(eachSession) {
                                            return eachSession._id == doc.session_id
                                        })
                                        if (thisSessionDetails && !_.find(self.sessions, function(sess) {
                                                return sess._id == thisSessionDetails._id
                                            })) {
                                            self.sessions.push({
                                                _id: thisSessionDetails._id,
                                                name: thisSessionDetails.name
                                            })
                                        }
                                    })
                                }


                                _.defer(function() {
                                    $scope.$apply();
                                });
                            }
                        })
                    }


                    /*
                     * To get school based settings
                     *
                     * @Developer : Jeevanantham N
                     */
                    let getAcademicSettings = () => {
                        authService.callAPI(filterCons.API_GET_SCHOOL_SETTINGS + localStorageService.get('school_id'), "GET", {}, (response) => {
                            try {
                                console.log(response)
                                if (response.result && response.result.data) {
                                    self.rolePackage = response.result.data.role_det ? response.result.data.role_det : []

                                    self.allSessions = response.result.data.session_det ? response.result.data.session_det : []

                                    self.allCurriculum = response.result.data.curriculum_det ? response.result.data.curriculum_det : []

                                    self.allClassess = response.result.data.class_det ? response.result.data.class_det : []

                                    self.allBatchess = response.result.data.batch_det ? response.result.data.batch_det : []

                                    self.allSubjectsList = response.result.data.subject_det ? response.result.data.subject_det : []

                                    if (self.allSessions && academicDetail) {
                                        _.each(academicDetail, function(doc) {
                                            let thisSessionDetails = _.find(self.allSessions.list, function(eachSession) {
                                                return eachSession._id == doc.session_id
                                            })
                                            if (thisSessionDetails && !_.find(self.sessions, function(sess) {
                                                    return sess._id == thisSessionDetails._id
                                                })) {
                                                self.sessions.push({
                                                    _id: thisSessionDetails._id,
                                                    name: thisSessionDetails.name
                                                })
                                            }
                                        })
                                    }

                                    self.allRoles = [];

                                    if ($scope.isClub) {
                                        if (self.rolePackage) {
                                            _.each(self.rolePackage.list, function(role) {
                                                if ((role._id != CONSTANTS.ADMIN_ID && role._id != parentId && role._id != senEducatorId && role._id != senCoordinatorId && role._id != principalId && role._id != vicePrincipalId && role._id != senCounselorId && role.status === true)) {
                                                    self.allRoles.push(role)
                                                }
                                            })
                                        }
                                    } else if (self.rolePackage) {
                                        self.allRoles = _.filter(self.rolePackage.list, function(role) {
                                            return role._id != CONSTANTS.ADMIN_ID && role.status === true
                                        })
                                        // if($scope.stateId == "userManagement"){
                                        //     let roleNames = ["Student", "Teacher"]
                                        //     let roleArrayOfuserManagement = []
                                        //     _.each(roleNames, function(oneRoleName){
                                        //         let ex = _.find(self.allRoles, function(oneRole){
                                        //             return oneRole.name == oneRoleName
                                        //         })
                                        //         if(ex){
                                        //             roleArrayOfuserManagement.push(ex)
                                        //         }
                                        //     })
                                        //     if(roleArrayOfuserManagement.length){
                                        //         self.allRoles = roleArrayOfuserManagement
                                        //     }
                                        // }
                                    } else {
                                        return false;
                                    }

                                    getSubJectPack()

                                    _.defer(function() {
                                        $scope.$apply();
                                    });
                                }
                            } catch (e) {
                                console.log(e)
                            }
                        })
                    }

                    /*
                     * To get saved search details
                     *
                     * @Developer : Jeevanantham N
                     */
                    let getSavedSearch = () => {
                        authService.callAPI(filterCons.API_GET_SAVED_SEARCH + localStorageService.get('school_id') + "/" + $scope.stateId, "GET", {}, (response) => {
                            //console.log(response)
                            if (response.result && response.result.data && response.result.data.search_det) {
                                //$scope.hodPersonArr = response.result.data.departments

                                $scope.savedSearchData = response.result.data.search_det

                                _.defer(function() {
                                    $scope.$apply();
                                });
                            }
                        })
                    }

                    /*
                     * To get user's academic details
                     *
                     * @Developer : Jeevanantham N
                     */
                    let userPrsnData = (user_id) => {
                        authService.callAPI(filterCons.API_GET_PERSON_ACDEMICS + localStorageService.get('school_id') + "/" + userId, "GET", {}, (response) => {

                            if (response.result && response.result.data && response.result.data.person_data) {
                                $scope.persnData = response.result.data.person_data

                                _.defer(function() {
                                    $scope.$apply();
                                });
                            }
                        })
                    }

                    let initSubs = () => {
                        //subsModules = self.subscribe('getModulesFeaturesForFilter', () => [localStorageService.get('school_id')])
                        //subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [localStorageService.get('school_id')])
                        //subsAcademicSet = self.subscribe('getAllAcademicSettings', () => [localStorageService.get('school_id')])
                    }

                    this.$onInit = () => {
                        //initSubs()
                        getUserModules()
                        getAcademicSettings()
                        getAcademicPck()
                        getSavedSearch()
                        userPrsnData()
                    }

                    this.$onDestroy = () => {
                        if (subsModules)
                            subsModules.stop()
                        if (subsAcademicSet)
                            subsAcademicSet.stop()
                        if (subsAcademicPack)
                            subsAcademicPack.stop()
                    }


                    /* self.autorun(() => {
                    let moduleDetails = Modules_features_new.findOne({
                        state: "roleSetting",
                        school_id: localStorageService.get('school_id')
                    })
                    let parentId = ''
                    let principalId = ''
                    let vicePrincipalId = ''
                    let senEducatorId = ''
                    let senCoordinatorId = ''
                    let senCounselorId = ''
                    if (moduleDetails != undefined && $scope.isClub) {
                        console.log("moduleDetails.feature_role")
                        console.log(moduleDetails.feature_role)
                        _.each(moduleDetails.feature_role, function(each) {
                            if (each.f_id == 'parentComponent' && each.privilege[0].status) {
                                parentId = each.role_id
                            } else if (each.f_id == 'principalComponent' && each.privilege[0].status) {
                                principalId = each.role_id
                            } else if (each.f_id == 'vicePrincipalComponent' && each.privilege[0].status) {
                                vicePrincipalId = each.role_id
                            } else if (each.f_id == 'senEducatorComponent' && each.privilege[0].status) {
                                senEducatorId = each.role_id
                            } else if (each.f_id == 'senCoordinatorComponent' && each.privilege[0].status) {
                                senCoordinatorId = each.role_id
                            } else if (each.f_id == 'senCounselorComponent' && each.privilege[0].status) {
                                senCounselorId = each.role_id
                            }
                        })
                    }
                    self.rolePackage = Settings.findOne({
                        school_id: localStorageService.get('school_id'),
                        type: "role"
                    })

                    self.allSessions = Settings.find({
                        school_id: localStorageService.get('school_id'),
                        type: "session"
                    }).fetch();

                    self.allCurriculum = Settings.find({
                        school_id: localStorageService.get('school_id'),
                        type: "curriculum"
                    }).fetch();

                    self.allClassess = Settings.find({
                        school_id: localStorageService.get('school_id'),
                        type: "class"
                    }).fetch();

                    self.allBatchess = Settings.find({
                        school_id: localStorageService.get('school_id'),
                        type: "batch"
                    }).fetch();

                    self.allSubjectsList = Settings.find({
                        school_id: localStorageService.get('school_id'),
                        type: "subject"
                    }).fetch();
                    self.allRoles = [];
                    if ($scope.isClub) {
                        console.log("self.rolePackage.list")
                        console.log(self.rolePackage.list)
                        if (self.rolePackage) {
                            _.each(self.rolePackage.list, function(role) {
                                if ((role._id != CONSTANTS.ADMIN_ID && role._id != parentId && role._id != senEducatorId && role._id != senCoordinatorId && role._id != principalId && role._id != vicePrincipalId && role._id != senCounselorId && role.status === true)) {
                                    self.allRoles.push(role)
                                }
                            })
                        }
                    } else if (self.rolePackage) {
                        self.allRoles = _.filter(self.rolePackage.list, function(role) {
                            return role._id != CONSTANTS.ADMIN_ID && role.status === true
                        })
                    } else {
                        return false;
                    }
                    getSubJectPack()
                    self.sessions = []
                    let academicDetail = AcademicConsole.find({
                        school_id: localStorageService.get('school_id')
                    }).fetch();

                    if (academicDetail === undefined || academicDetail.length <= 0)
                        return false;
                    _.each(academicDetail, function(doc) {
                        let thisSessionDetails = _.find(self.allSessions.list, function(eachSession) {
                            return eachSession._id == doc.session_id
                        })
                        if (thisSessionDetails && !_.find(self.sessions, function(sess) {
                                return sess._id == thisSessionDetails._id
                            })) {
                            self.sessions.push({
                                _id: thisSessionDetails._id,
                                name: thisSessionDetails.name
                            })
                        }
                    })
                    $scope.savedSearchData = SavedSearches.find({
                        school_id: localStorageService.get('school_id'),
                        state: $scope.stateId
                    }).fetch()
                }) */


                    function getSubJectPack() {
                        self.allSubjects = _.flatten(_.pluck(self.allSubjectsList, 'list'))
                    }

                    self.getRoleDetails = (id) => {
                        if (self.selectedSavedSerach != undefined) {
                            if (self.selectedSavedSerach.role != id) {
                                $scope.selectedFilterData = "Select.. "
                            };

                        };

                        try {
                            $scope.multiRoles = _.filter(self.rolePackage.list, function(role) {
                                return role._id != SuperAdminTYPE && role._id != AdminTYPE && role._id != id && role.status === true
                            })

                        } catch (ex) {


                        }
                    }

                    function clearFilterResult() {
                        if ($scope.stateId) {

                            $scope.clearParentFields();
                        }
                    }

                    $scope.setFilterObj = function(data, key) {
                        console.log(data)
                        console.log(key)
                        console.log($scope.filterObj)
                        $scope.open = false;
                        clearFilterResult()
                        if (key == 'Role') {
                            $scope.filterObj['role'] = data
                            clearComponentField()
                        } else if (key == 'Session') {
                            $scope.filterObj['session'] = data
                        } else if (key == 'Curiculum') {
                            $scope.filterObj['curriculum'] = data
                        } else if (key == 'role_id') {
                            clearComponentField()
                            $scope.filterObj['role_id'] = data
                            CommonFilterRoleService.setSelectedRole(data)
                        } else if (key == 'Chart') {
                            $scope.filterObj['chart'] = data
                        } else if (key == 'Multi') {
                            $scope.filterObj['multirole'] = data
                        }
                    }

                    function clearComponentField() {
                        $scope.filteredEndorsedUsers = [];
                        self.userEndorsedAcademic = [];
                        self.userNotEndorsedAcademic = [];
                        $scope.userNamesNotEndorsed = [];
                        $scope.filteredNotEndorsedUsers = [];
                        vm.pager = {};
                        vm.setPage = setPage;
                        vm.pageIndex = [];
                        self.allItemsSelected = [];
                    }

                    $scope.removeFilter = function() {
                        $scope.filterObj = {}
                        $scope.filteredExamDetails = []
                    }

                    $scope.setSessionFilters = (item) => {
                        let items = item.split(",")
                    }

                    $scope.deleteSearch = (item) => {
                        $scope.open = false;

                        /* Meteor.call('deleteSearchDetails', item._id, localStorageService.get('school_id'), function(err, res) {
                            if (err) {
                                $scope.loading = false;
                                toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                            } else {
                                getSavedSearch()
                                $scope.selectedFilterData = "Select.. "
                                toastr.success('Deleted Successfully')
                            }
                        }) */

                        let obj = {
                            'search_id': item._id,
                            'school_id': localStorageService.get('school_id')
                        }

                        /*
                         * To removed filter data
                         *
                         * @Developer : Jeevanantham N
                         */
                        authService.callAPI(filterCons.API_POST_REMOVE_SERACH, "POST", obj, (response) => {
                            //console.log(response)
                            if (response.result && response.result.data && response.result.data.info) {
                                $scope.selectedFilterData = "Select.. "
                                getSavedSearch()
                                toastr.success('Deleted Successfully')
                            } else {
                                $scope.loading = false;
                                toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                            }
                        })

                    }
					function _breakReference(data) {
                        try {
                            let keys = Object.keys(data)
                            let obj = {}
                            for (let k = 0; k < keys.length; k++) {
                                obj[keys[k]] = data[keys[k]]
                            }
                            return obj
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    self.getBatch = function(bid) {

                        //console.log("wwwwwwwwww")
                        $scope.open = false;
                        clearUsersListResults();
                        $scope.batchId = bid
                        $scope.isBatch = true
                        $scope.isSubject = false
                        $scope.filterObj['batch'] = []
                        $scope.filterObj['subject'] = [];
                        let flag = false;
                        for (let i = 0; i < $scope.filterObj['xclass'].length; i++) {
                            if ($scope.filterObj['xclass'][i] === bid) {
                                flag = true
                            }
                        }
                        self.showMultiSubject = [];
                        self.checkAll = false
                        self.checkAllSubject = false

                        /* self.showThisBatch = AcademicConsole.findOne({
                            session_id: $scope.selectCuriculum,
                            curriculum_id: $scope.selectClass
                        }, {
                            xclass: 1
                        }) */

                        self.showThisBatch = _.find(academicDetail, (lst) => {
                            return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass
                        })

                        var classDet = _.find(self.showThisBatch.xclass, function(batch) {
                            return batch._id === bid
                        })

                        if ($scope.isTeacher && userId && self.allClassess) {

                            /* let personDetails = Person.findOne({
                                user_id: Meteor.userId(),
                                "status": "active"
                            }) */

                            let personDetails = $scope.persnData

                            if (personDetails && personDetails.details) {

                                let batchData = _.where(personDetails.details, {
                                    session_id: $scope.filterObj['session'],
                                    curriculum_id: $scope.filterObj['curriculum'],
                                    class_id: bid
                                });

                                batchData = _.uniq(_.flatten(_.pluck(batchData, "batch_id")))

                                self.showBatchName = _.filter(self.allBatches.list, function(data) {
                                    return batchData.indexOf(data._id) !== -1
                                })
                            }
                        } else {

                            if (flag) {
                                for (let j = 0; j < classDet.batches.length; j++) {
                                    for (let jj = 0; jj < self.showBatchName.length; jj++) {
                                        if (self.showBatchName[jj]._id === classDet.batches[j]) {
                                            self.showBatchName.splice(jj, 1)
                                            break;
                                        }
                                    }
                                }
                            } else {
								self.showBatchName = []
                                for (let index = 0; index < classDet.batches.length; index++) {
                                    try {
                                        let bId = classDet.batches[index];
                                        let ex = _.find(self.allBatchess.list, function(one){
                                            return one._id == bId
                                        })
                                        if(ex){
                                            self.showBatchName.push(_breakReference(ex))
                                        }
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }
                                if(!self.showBatchName.length){
                                    _.each(self.allBatchess.list, function(v) {
                                        _.each(classDet.batches, function(k) {
                                            if (v._id === k) {
                                                var item = {
                                                    _id: v._id,
                                                    name: v.name
                                                }
                                                self.showBatchName.push(item)
                                            }
                                        })
                                    })
                                }
                            }
                        }
                        self.showMultiBatch = _.uniq(self.showBatchName, false, function(p) {
                            return p._id;
                        });
                        if (self.showMultiBatch.length <= 0) {
                            $scope.isBatch = false
                        }
                    }

                    self.getClass = function(sid) {
                        clearFilterResult()
                        $scope.open = false;

                        if (self.selectedSavedSerach != undefined) {
                            if (self.selectedSavedSerach.curriculum != sid) {
                                $scope.selectedFilterData = "Select.. "
                            };
                        };
                        let cid = $scope.selectCuriculum;
                        $scope.selectClass = sid;
                        let addedClass = [];
                        self.showClassName = [];
                        $scope.isBatch = false
                        $scope.filterObj['xclass'] = []
                        $scope.filterObj['singlefieldclass'] = undefined;
                        clearFields();
                        /* self.showThisClass = AcademicConsole.find({
                            session_id: cid,
                            curriculum_id: sid
                        }).fetch(); */

                        self.showThisClass = _.filter(academicDetail, (lst) => {
                            return lst.session_id == cid && lst.curriculum_id == sid
                        })

                        //console.log(self.showThisClass)
                        //console.log(cid)
                        //console.log(sid)

                        if (self.showThisClass != undefined && self.showThisClass.length > 0) {
                            _.each(self.showThisClass[0].xclass, function(classes) {
                                addedClass.push(classes._id)
                            })
                        }
                        addedClass = _.uniq(addedClass);

                        //console.log(addedClass)

                        if ($scope.isTeacher && userId && self.allClassess) {
                            /* let personDetails = Person.findOne({
                                user_id: Meteor.userId(),
                                "status": "active"
                            }) */

                            let personDetails = $scope.persnData

                            //console.log("===11111===")
                            //console.log(personDetails)

                            if (personDetails && personDetails.details) {
                                let classData = _.where(personDetails.details, {
                                    session_id: $scope.filterObj['session'],
                                    curriculum_id: sid
                                });

                                classData = _.uniq(_.flatten(_.pluck(classData, "class_id")))

                                self.showClassName = _.filter(self.allClassess.list, function(data) {
                                        return classData.indexOf(data._id) !== -1
                                    })
                                    //
                            }
                        } else {
                            //console.log("===2222===")
                            //console.log(self.allClassess)
                            if (self.allClassess != undefined) {
                                _.each(self.allClassess.list, function(v) {
                                    _.each(addedClass, function(k) {
                                        if (v._id === k) {
                                            var item = {
                                                _id: v._id,
                                                name: v.name
                                            }
                                            self.showClassName.push(item)
                                        }
                                    })
                                })
                            }

                        }

                        //console.log(self.showClassName)

                        if (self.showClassName && self.showClassName.length > 0) {
                            $scope.isClass = true
                        }

                        self.classArr = _.pluck(self.showClassName, "_id")
                    }

                    self.getCuriculum = function(cid) {
                        $scope.open = false;
                        if (self.selectedSavedSerach != undefined) {
                            if (self.selectedSavedSerach.session != cid) {
                                $scope.selectedFilterData = "Select.. "
                            };
                        };

                        $scope.selectCuriculum = cid;
                        self.showCurriculumName = [];
                        let addedCuricullumID = [];
                        $scope.filterObj['curriculum'] = undefined
                        $scope.filterObj['xclass'] = []
                        $scope.filterObj['singlefieldclass'] = undefined;
                        clearFields()
                        self.showMultiBatch = []
                        self.checkAllClass = false
                        self.showClassName = [];
                        self.showBatchName = [];
                        $scope.isBatch = false
                        $scope.isClass = false

                        /* self.showThisSessions = AcademicConsole.find({
                            session_id: cid
                        }).fetch(); */

                        self.showThisSessions = _.filter(academicDetail, (lst) => {
                            return lst.session_id == cid
                        })

                        _.each(self.showThisSessions, function(v) {
                            addedCuricullumID.push(v.curriculum_id)
                        })
                        addedCuricullumID = _.uniq(addedCuricullumID);
                        self.showCurriculumName = [];

                        if ($scope.isTeacher && userId && self.allCurriculum) {
                            /* let personDetails = Person.findOne({
                                user_id: Meteor.userId(),
                                "status": "active"
                            }) */

                            let personDetails = $scope.persnData

                            if (personDetails && personDetails.details) {
                                let currData = _.where(personDetails.details, {
                                    session_id: cid
                                });

                                currData = _.uniq(_.flatten(_.pluck(currData, "curriculum_id")))

                                self.showCurriculumName = _.filter(self.allCurriculum.list, function(data) {
                                    return currData.indexOf(data._id) !== -1
                                })
                            }
                        } else {

                            _.each(self.allCurriculum.list, function(v) {
                                _.each(addedCuricullumID, function(k) {
                                    if (v._id === k) {
                                        var item = {
                                            _id: v._id,
                                            name: v.name
                                        }
                                        self.showCurriculumName.push(item)
                                    }

                                })
                            })
                        }
                    }

                    self.getSubject = function() {
                        $scope.open = false;
                        self.checkAllSubject = false
                        getAllSubject();
                    }

                    function getAllSubject() {
                        $scope.open = false;
                        $scope.isSubject = true
                        $scope.filterObj['subject'] = [];
                        self.showMultiSubject = [];
                        /* self.showThisSubject = AcademicConsole.findOne({
                            session_id: $scope.selectCuriculum,
                            curriculum_id: $scope.selectClass
                        }, {
                            subject_package: 1
                        }) */

                        self.showThisSubject = _.find(academicDetail, (lst) => {
                            return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass
                        })

                        let allSubject = _.flatten(_.pluck(self.showThisSubject.subject_package, 'subjects'))
                        _.each(self.allSubjects, function(v) {
                            _.each(allSubject, function(k) {
                                if (v._id === k) {
                                    var item = {
                                        _id: v._id,
                                        name: v.name
                                    }
                                    self.showMultiSubject.push(item)
                                }
                            })
                        })

                        if (self.showMultiSubject.length <= 0) {
                            $scope.isSubject = false
                        } else {
                            self.checkAllSubject = false
                        }
                    }

                    $scope.selectBatches = (opt) => {
                        $scope.open = false;
                        clearUsersListResults();
                        clearFilterResult()
                        if (opt == "all") {
                            if (self.checkAll) {
                                $scope.filterObj['batch'] = _.union($scope.filterObj['batch'], _.pluck(self.showMultiBatch, "_id"))
                                getAllSubject();
                            } else {
                                $scope.filterObj['batch'] = []
                                self.showMultiSubject = []
                                $scope.isSubject = false
                            }
                        } else {
                            if ($scope.filterObj['batch'].length == _.pluck(self.showMultiBatch, "_id").length) {
                                self.checkAll = true
                            } else {
                                self.checkAll = false
                                if ($scope.filterObj['batch'].length === 0) {
                                    self.showMultiSubject = []
                                    $scope.isSubject = false
                                }
                            }
                        }
                        // if (self.selectedSavedSerach != undefined) {
                        //   if (self.selectedSavedSerach.batch.length != $scope.filterObj['batch'].length) {
                        //         self.selectedSavedSerach.batch=$scope.filterObj['batch']
                        //         self.selectedSavedSerach.title=""
                        //         $scope.saved_search = undefined
                        //         $scope.savedSearchData.push(self.selectedSavedSerach)
                        //         $scope.getSavedData(self.selectedSavedSerach)
                        //         $scope.savedSearchData = _.filter( $scope.savedSearchData, function(data) {
                        //         return data.title  !=""
                        //         })
                        //     };
                        // };
                    }

                    $scope.selectClasses = (opt) => {
                        $scope.open = false;
                        clearFilterResult()
                        if (opt == "all") {
                            if (self.checkAllClass) {
                                $scope.filterObj['xclass'] = _.union($scope.filterObj['xclass'], self.classArr)
                                filterBatchBasedOnClass(self.classArr);
                                clearFields()
                            } else {
                                $scope.filterObj['xclass'] = [];
                                clearFields()
                                self.showMultiBatch = [];
                                $scope.isBatch = false;
                                self.showBatchName = []


                            }
                        } else {
                            if ($scope.stateId === 'userManagement') {
                                $scope.filterObj['xclass'] = [];
                                $scope.filterObj['xclass'].push($scope.filterObj['singlefieldclass'])
                            }
                            if ($scope.filterObj['xclass'].length == self.classArr.length) {
                                self.checkAllClass = true
                            } else {
                                self.checkAllClass = false
                            }
                        }
                        //  if (self.selectedSavedSerach != undefined) {
                        //   if (self.selectedSavedSerach.class.length != self.classArr.length) {
                        //         self.selectedSavedSerach.class=self.classArr
                        //         self.selectedSavedSerach.title=""
                        //         $scope.saved_search = undefined
                        //         $scope.savedSearchData.push(self.selectedSavedSerach)
                        //         $scope.getSavedData(self.selectedSavedSerach)
                        //         $scope.savedSearchData = _.filter( $scope.savedSearchData, function(data) {
                        //         return data.title  !=""
                        //         })
                        //     };
                        // };
                    }

                    $scope.selectAnnouncementReceivers = (opt) => {
                        console.log(opt)
                    }

                    $scope.selectSubject = (opt) => {
                        $scope.open = false;
                        clearUsersListResults();
                        clearFilterResult()
                        if (opt == "all") {
                            if (self.checkAllSubject) {
                                $scope.filterObj['subject'] = _.union($scope.filterObj['subject'], _.pluck(self.showMultiSubject, "_id"))
                            } else {
                                $scope.filterObj['subject'] = [];
                            }
                        } else {
                            if ($scope.filterObj['subject'].length == self.showMultiSubject.length) {
                                self.checkAllSubject = true
                            } else {
                                self.checkAllSubject = false

                            }
                        }
                    }

                    function filterBatchBasedOnClass(totalClass) {
                        $scope.isBatch = true
                            /* self.showThisBatch = AcademicConsole.findOne({
                                session_id: $scope.selectCuriculum,
                                curriculum_id: $scope.selectClass
                            }, {
                                xclass: 1
                            }) */

                        self.showThisBatch = _.find(academicDetail, (lst) => {
                            return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass
                        })


                        self.showBatchName = [];
                        for (var i = totalClass.length - 1; i >= 0; i--) {
                            var classDet = _.find(self.showThisBatch.xclass, function(batch) {
                                return batch._id === totalClass[i]
                            })

                            _.each(self.allBatchess.list, function(v) {
                                _.each(classDet.batches, function(k) {
                                    if (v._id === k) {
                                        var item = {
                                            _id: v._id,
                                            name: v.name
                                        }
                                        self.showBatchName.push(item)
                                    }
                                })
                            })
                        }
                        self.showMultiBatch = _.uniq(self.showBatchName, false, function(p) {
                            return p._id;
                        });
                        if (self.showMultiBatch.length <= 0) {
                            $scope.isBatch = false
                        }
                    }

                    self.searchValuesBasedOnFilterOnComponent = function() {

                        $scope.open = false;
                        self.userFilter = {}
                        self.userFilter.roleId = $scope.filterObj.role_id
                        self.userFilter.sessionId = $scope.filterObj.session
                        self.userFilter.curriculumId = $scope.filterObj.curriculum
                        self.userFilter.classId = $scope.filterObj.xclass
                        self.userFilter.batchId = $scope.filterObj.batch
                        $scope.isSearched = true;

                        if ($scope.filterObj === undefined || $scope.filterObj.role_id === undefined) {
                            toastr.error('Please Select the Role')
                            return false;
                        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.session === undefined)) {
                            toastr.error('Please Select the Session')
                            return false;
                        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.curriculum === undefined)) {
                            toastr.error('Please Select the Curriculum')
                            return false;
                        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.xclass === undefined || $scope.filterObj.xclass.length <= 0)) {
                            toastr.error('Please Select the Class')
                            return false;
                        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.batch === undefined || $scope.filterObj.batch.length <= 0)) {
                            toastr.error('Please Select the Batch')
                            return false;
                        }
                        setFilterValue($scope.filterObj)
                    }

                    function setFilterValue(userAcademicDetails) {

                        self.userMgt = {}
                        self.userMgt.roleId = userAcademicDetails.role_id
                        self.userMgt.sessionId = userAcademicDetails.session
                        self.userMgt.curriculumId = userAcademicDetails.curriculum
                        self.userMgt.classId = userAcademicDetails.xclass
                        self.userMgt.batchId = userAcademicDetails.batch
                            // self.getUsersLists(0, limit);
                        initController();
                    }

                    //Added for sending announcement to all users without listing list
                    self.getAllUsersForAnnouncement = () => {
                        $scope.loading = true

                        let req = vm.userMgt
                        req["school_id"] = localStorageService.get('school_id')
                        req.user_id = localStorageService.get('user_id')


                        /*
                         * To get all users against selected role
                         *
                         * @Developer : Jeevanantham N
                         */
                        authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, (response) => {
                            if (response.result && response.result.data && response.result.data.users) {
                                if ((response.result.data.users === undefined || response.result.data.users.length === 0))
                                    toastr.error("No results found");
                                else if ((response.result.data.users && response.result.data.users.length != 0)) {
                                    //console.log('**************')
                                    // $scope.filteredNotEndorsedUsers = res.users
                                    $scope.filteredNotEndorsedUsers.push(...response.result.data.users);
                                    //console.log($scope.filteredNotEndorsedUsers)
                                    //console.log('**************')
                                    $scope.ProcessValue()
                                }

                                $scope.loading = false;
                                _.defer(function() {
                                    $scope.$apply();
                                });
                            } else {
                                $scope.loading = false;
                                toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                            }
                        })

                        /* Meteor.call('getAllUserDetails', vm.userMgt, localStorageService.get('school_id'), null, null, function (err, res) {
                        if (err) {
                            $scope.loading = false;
                            toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                        } else {
                            if ((res.users === undefined || res.users.length === 0))
                                toastr.error("No results found");
                            else if ((res.users && res.users.length != 0)) {
                                console.log('**************')
                                // $scope.filteredNotEndorsedUsers = res.users
                                $scope.filteredNotEndorsedUsers.push(...res.users);
                                console.log($scope.filteredNotEndorsedUsers)
                                console.log('**************')
                                $scope.ProcessValue()
                            }

                            $scope.loading = false;
                            _.defer(function () {
                                $scope.$apply();
                            });;
                        }
                    }) */
                    }

                    self.getUsersLists = (skip, limit, page) => {
                        $scope.open = false;
                        self.showList = true
                            // self.allItemsSelected = []
                        $scope.loading = true

                        let req = vm.userMgt
                        req["school_id"] = localStorageService.get('school_id')
                        req.user_id = localStorageService.get('user_id')
                        req["skip"] = skip
                        req["limit"] = limit

                        /*
                         * To get all users against selected role
                         *
                         * @Developer : Jeevanantham N
                         */
                        authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, (response) => {
                            //console.log(response)
                            if (response.result && response.result.data && response.result.data.users) {
                                if ((response.result.data.users === undefined || response.result.data.users.length === 0)) {
                                    $scope.loading = false;
                                    toastr.error("No results found");
                                } else if ((response.result.data.users && response.result.data.users.length != 0)) {
                                    vm.Items = response.result.data.totallength;
                                    vm.pager = GetPager(vm.Items, page);
                                    vm.pageIndex.push(page);
                                    bindData(response.result.data, page)
                                }

                                let userList = []
                                if ($scope.isClub && $scope.userNames) {
                                    let availableMembers = _.uniq(_.pluck($scope.userNames, 'user_id'));
                                    _.each($scope.filteredNotEndorsedUsers, function(each, index) {
                                        if (availableMembers.indexOf(each._id) != -1) {
                                            each.isExists = true
                                        }
                                    })

                                    $scope.userNamesNotEndorsed = $scope.filteredNotEndorsedUsers
                                    $scope.userNamesNotEndorsed.sort(function(a, b) {
                                        var textA = a.name.toUpperCase();
                                        var textB = b.name.toUpperCase();
                                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                                    });
                                }

                                $scope.loading = false;
                                $scope.UniqueNoText = "Employee No";

                                if ($scope.userNamesNotEndorsed.length && $scope.userNamesNotEndorsed[0].role == "student") {
                                    $scope.UniqueNoText = "Admission No";
                                }

                                _.defer(function() {
                                    $scope.$apply();
                                });
                            } else {
                                $scope.loading = false;
                                toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                            }
                        })


                        /* Meteor.call('getAllUserDetails', vm.userMgt, localStorageService.get('school_id'), skip, limit, function(err, res) {
                        if (err) {
                            $scope.loading = false;
                            toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                        } else {
                            if ((res.users === undefined || res.users.length === 0))
                                toastr.error("No results found");
                            else if ((res.users && res.users.length != 0)) {
                                vm.Items = res.totallength;
                                vm.pager = GetPager(vm.Items, page);
                                vm.pageIndex.push(page);
                                bindData(res, page)
                            }
                            let userList = []
                            if ($scope.isClub && $scope.userNames) {
                                let availableMembers = _.uniq(_.pluck($scope.userNames, 'user_id'));
                                _.each($scope.filteredNotEndorsedUsers, function(each, index) {
                                    if (availableMembers.indexOf(each._id) != -1) {
                                        each.isExists = true
                                    }
                                })

                                $scope.userNamesNotEndorsed = $scope.filteredNotEndorsedUsers
                                $scope.userNamesNotEndorsed.sort(function(a, b) {
                                    var textA = a.name.toUpperCase();
                                    var textB = b.name.toUpperCase();
                                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                                });
                            }

                            $scope.loading = false;
                            if ($scope.userNamesNotEndorsed[0].role == "student") {
                                $scope.UniqueNoText = "Admission No";
                            } else {

                                $scope.UniqueNoText = "Employee No";
                            }
                            _.defer(function() {
                                $scope.$apply();
                            });;
                        }
                    }) */
                    }

                    function bindData(res, page) {
                        _.each(res.users, function(user) {
                            user.page = page
                        })
                        $scope.userNamesNotEndorsed = res.users;
                        $scope.userNamesNotEndorsed.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        $scope.filteredNotEndorsedUsers.push(...res.users);
                        $scope.filteredNotEndorsedUsers.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        self.userNotEndorsedAcademic = _.uniq(_.pluck(res.users, 'academic_details'));
                        self.userNotEndorsedAcademic.sort(function(a, b) {
                            if (a.name && b.name) {
                                var textA = a.name.toUpperCase();
                                var textB = b.name.toUpperCase();
                                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                            }
                        });
                    }

                    self.selectAllNotEndorsed = (selected, index, acade) => {
                        $scope.open = false;
                        if (acade != undefined) {
                            let cnt = 0
                            _.each($scope.filteredNotEndorsedUsers, function(user) {
                                if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                                    cnt = cnt + 1;
                                    user.isChecked = selected
                                }
                            })
                            let userTo = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                                return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage
                            })

                            if (cnt === userTo.length) {
                                self.allItemsSelected[vm.pager.currentPage][index] = true
                            } else {
                                self.allItemsSelected[vm.pager.currentPage][index] = false;
                            }

                        } else {
                            _.each($scope.filteredNotEndorsedUsers, function(user) {
                                if (user.page == vm.pager.currentPage)
                                    user.isChecked = selected
                            })
                        }
                        $scope.filteredNotEndorsedUsers.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                    }


                    self.getClickedNotEndorsedUser = (person, index, acade) => {
                        $scope.open = false;
                        if (acade != undefined) {
                            let cnt = 0
                            _.each($scope.filteredNotEndorsedUsers, function(user) {
                                if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                                    cnt = cnt + 1;
                                }
                            })

                            let userTo = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                                return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage
                            })

                            if (cnt === userTo.length) {
                                self.allItemsSelected[vm.pager.currentPage][index] = true
                            } else {
                                self.allItemsSelected[vm.pager.currentPage][index] = false
                            }

                        } else {
                            let userTo = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                                return user.isChecked === true && user.page == vm.pager.currentPage
                            })
                            if ($scope.filteredNotEndorsedUsers.length === userTo.length) {
                                self.allItemsSelected[vm.pager.currentPage] = true
                            } else {
                                self.allItemsSelected[vm.pager.currentPage] = false
                            }
                        }
                        $scope.filteredNotEndorsedUsers.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });

                    }


                    $scope.saveSearchFilter = () => {
                        $scope.open = false;

                        var filterItem = {
                            'school_id': localStorageService.get('school_id'),
                            'title': self.saveName,
                            'state': $scope.stateId,
                            'role': $scope.filterObj.role_id,
                            'session': $scope.filterObj.session,
                            'curriculum': $scope.filterObj.curriculum,
                            'class': $scope.filterObj.xclass,
                            'batch': $scope.filterObj.batch,
                            'subject': $scope.filterObj.subject,
                            'check_all_batch': self.checkAll,
                            'check_all_class': self.checkAllClass,
                            'check_all_subject': self.checkAllSubject,
                            'chart_type': $scope.filterObj.chart,
                            'multirole': $scope.filterObj.multirole
                        }

                        if ($scope.filterObj.role_id === undefined && $scope.filterObj.session === undefined) {
                            toastr.error("Please select atleast one field")
                            return false
                        }

                        if (!self.saveName) {
                            toastr.error("Please enter title")
                            return false
                        }

                        /*
                         * To add filter data
                         *
                         * @Developer : Jeevanantham N
                         */
                        authService.callAPI(filterCons.API_POST_ADD_SERACH, "POST", filterItem, (response) => {
                            //console.log(response)
                            if (response.result && response.result.data && response.result.data.info) {
                                self.saveName = undefined;
                                getSavedSearch()
                                toastr.success("Successfully saved");
                            } else {
                                $scope.loading = false;
                                toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                            }
                        })


                        /* Meteor.call("saveSearch", filterItem, function(error, result) {
                            if (error) { // if it fails, show error message
                                toastr.error(error.reason);
                                return;
                            } else {
                                self.saveName = undefined;
                                _.defer(function() {
                                    $scope.$apply();
                                });;
                                getSavedSearch()
                                toastr.success("Successfully saved");
                            }
                        }); */
                    }

                    $scope.openDropdown = function(data) {

                        if (data) {
                            $scope.open = !$scope.open;
                        }
                    };


                    $scope.getSavedData = (savedDet) => {
                        $scope.open = false;
                        $scope.selectedFilterData = savedDet.title
                            // $scope.openDropdown("open");
                        self.selectedSavedSerach = savedDet
                        clearComponentField()
                        self.getCuriculum(savedDet.session)
                        self.getClass(savedDet.curriculum)
                        $scope.filterObj['role'] = savedDet.role;
                        $scope.filterObj['session'] = savedDet.session;
                        $scope.filterObj['curriculum'] = savedDet.curriculum;
                        $scope.selectCuriculum = savedDet.session;

                        if (savedDet.check_all_class) {
                            $scope.selectClasses('all')
                        }

                        if (savedDet.class != undefined) {
                            if ($scope.stateId === 'userManagement') {
                                self.getBatch(savedDet.class[0])
                                $scope.filterObj['xclass'] = [];
                                $scope.filterObj['xclass'].push(savedDet.class);
                                $scope.filterObj['singlefieldclass'] = savedDet.class[0];
                            } else {
                                for (var i = savedDet.class.length - 1; i >= 0; i--) {
                                    self.getBatch(savedDet.class[i])
                                }
                            }

                        }

                        if (savedDet.check_all_batch) {
                            self.checkAll = true
                            $scope.selectBatches('all')
                        }
                        $scope.filterObj['xclass'] = savedDet.class
                        $scope.filterObj['batch'] = savedDet.batch
                        $scope.filterObj['subject'] = savedDet.subject
                        $scope.filterObj['role_id'] = savedDet.role
                        self.checkAllClass = savedDet.check_all_class
                        self.checkAllSubject = savedDet.check_all_subject
                        $scope.filterObj['chart'] = savedDet.chart_type
                        $scope.filterObj['multirole'] = savedDet.multirole
                        $scope.selectCuriculum = savedDet.session

                        try {
                            if ($scope.stateId === 'userManagement') {

                                $scope.searchValuesBasedOnFilter();
                            }
                        } catch (ex) {

                        }
                    }

                    $scope.unsetValue = () => {
                        $scope.saved_search = null
                    }

                }
            ]

        }
    });

/* component(name, {
    template: commonFilterTpl,
    controllerAs: name,
    bindings: {
        stateId: '<',
        searchValuesBasedOnFilter: '&searchfilter'
    },
    scope: {
        searchValuesBasedOnFilter: '&searchfilter'
    },
    controller: commonFilterCtrl
}); */

module.constant("filterCons", {
    API_GET_SCHOOL_SETTINGS: "/v0/endorsement/school/settings/",
    API_GET_SCHOOL_ACADEMICS: "/v0/endorsement/school/academics/",
    API_GET_SAVED_SEARCH: "/v0/endorsement/saved_searches/",
    API_GET_MODULE_FEATURE: "/v0/endorsement/module_features/",
    API_GET_PERSON_ACDEMICS: "/v0/endorsement/person_academics/",
    API_POST_ENDORSED_USERS: "/v0/endorsement/users_list",
    API_GET_SUBJECT_PACK_LIST: "/v0/endorsement/get_sub_pack_details",
    API_GET_SCHOOL_SUBJECT_PACK_LIST: "/v0/endorsement/get_school_sub_pack_details/",
    API_GET_TEACHER_MAIN_SUBJ: "/v0/endorsement/get_main_teacher_lst/",
    API_POST_GET_ALL_USERS: "/v0/endorsement/get_all_users",
    API_POST_ADD_SERACH: "/v0/endorsement/add_save_search",
    API_POST_REMOVE_SERACH: "/v0/endorsement/remove_save_search",
    API_POST_STUDENT_SUB_LIST: "/v0/endorsement/get_stu_subjects",
    API_POST_UPDATE_STU_ENDORSEMENT: "/v0/endorsement/update_endorsement",
    API_POST_DELETE_STU_ENDORSEMENT: "/v0/endorsement/delete_endorsement",
    API_POST_BULK_DELETE_STU_ENDORSEMENT: "/v0/endorsement/delete_bulk_endorsement",
    STUDENTROLEID: "student"
});

module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('commonFilter', {
            parent: 'app',
            url: '/commonFilter',
            views: {
                '@': {
                    template: commonFilterTpl,
                    controller: commonFilterCtrl,
                    controllerAs: 'multipleBatchFilterCtrl'
                }
            }
        })

});



// WEBPACK FOOTER //
// ./src/app/commonFilter/commonFilterModule.js